'use strict';

var chunkV6YUYBTJ_js = require('./chunk-V6YUYBTJ.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var S = require('clsx');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var S__default = /*#__PURE__*/_interopDefault(S);

var A=({label:a,buttonType:s,onClick:i,href:e,buttonAriaLabel:m,padding:l,margin:p,iconName:t,reverse:c,disabled:n,buttonRef:d,dataTestId:b,className:f,...u})=>{let g=`${chunk32OAM7MJ_js.a}-button`,y=S__default.default(g,s,f,{reverse:c,disabled:n});return jsxRuntime.jsxs(e?"a":"button",{href:e||void 0,className:y,style:{padding:l,margin:p},onClick:i,"aria-label":m,disabled:n,"data-testid":b,ref:d,...u,children:[t&&jsxRuntime.jsx(chunkV6YUYBTJ_js.b,{name:t,referenceSize:"span"}),a]})},x=A;

exports.a = x;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-WWL7ZO6T.js.map